module.exports = __webpack_public_path__ + "static/media/landmark.b77b8034.svg";